exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.date-range-open-btn > button {\n    background-color: #fff;\n    border: 1px solid #c6c6c6;\n    border-left: 1px solid #c6c6c6 !important;\n    border-right: 1px solid #c6c6c6 !important;\n    padding: 4px 8px 3px 8px;\n    margin-bottom: 1px;\n    margin-top: -1px;\n}\n", ""]);

// exports
